import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, isDevMode } from '@angular/core';
import { provideRouter, Router, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CoreModule } from './core/core.module';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { errorInterceptor } from './core/http/error.interceptor';
import { authInterceptor } from './core/http/auth.interceptor';
import { AuthService } from './core/auth/services/auth.service';
import * as Sentry from "@sentry/angular";

// Console override function for production
function overrideConsoleInProduction() {
  if (!isDevMode()) {
    // Override console methods in production
    const noop = () => {};
    
    // Override all console methods to prevent logging in production
    console.log = noop;
    console.info = noop;
    console.warn = noop;
    console.error = noop;
    console.debug = noop;
    console.trace = noop;
    console.table = noop;
    console.group = noop;
    console.groupEnd = noop;
    console.groupCollapsed = noop;
    console.time = noop;
    console.timeEnd = noop;
    console.timeLog = noop;
    console.count = noop;
    console.countReset = noop;
    console.clear = noop;
    console.dir = noop;
    console.dirxml = noop;
    console.assert = noop;
    console.profile = noop;
    console.profileEnd = noop;
    
    // Keep console.error for critical errors but make it minimal
    console.error = (...args: any[]) => {
      // Only log critical errors to Sentry or external monitoring
      if (args.length > 0 && typeof args[0] === 'string' && args[0].includes('CRITICAL')) {
        // You can add external logging here if needed
        return;
      }
    };
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withRouterConfig({ paramsInheritanceStrategy: 'always' })), AuthService, provideHttpClient(withFetch(), withInterceptors([authInterceptor, errorInterceptor])), provideClientHydration(), provideAnimationsAsync(), {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
        // Override console in production
        overrideConsoleInProduction();
      },
      deps: [Sentry.TraceService],
      multi: true,
    },]
};
// { provide: BROWSER_STORAGE, useValue: window.localStorage}